<template>
  <AppModal :model-value="true" class="version-history-modal" @update:model-value="$emit('close')">
    <h3>Version History</h3>

    <div class="modal-body">
      <div v-if="versions.length === 0" class="no-versions">
        No previous versions found.
      </div>

      <div v-else class="versions-list">
        <div v-for="version in versions" :key="version.id" class="version-item">
          <div class="version-header">
            <span class="version-number">Version {{ version.version }}</span>
            <span class="version-date">{{ formatDate(version.created_at) }}</span>
          </div>
          <div class="version-meta">
            <span v-if="version.changed_by">Changed by: {{ version.changed_by }}</span>
          </div>
          <div class="version-preview">
            <details>
              <summary>View Content</summary>
              <div class="preview-content">
                <div v-if="version.system_prompt" class="preview-section">
                  <strong>System Prompt:</strong>
                  <pre>{{ version.system_prompt }}</pre>
                </div>
                <div class="preview-section">
                  <strong>User Prompt:</strong>
                  <pre>{{ version.user_prompt }}</pre>
                </div>
              </div>
            </details>
          </div>
          <AppButton variant="outlined" size="small" @click="$emit('restore', version.version)">
            Restore This Version
          </AppButton>
        </div>
      </div>
    </div>
  </AppModal>
</template>

<script setup>
import { AppButton, AppModal } from "@/components/ui";

defineProps({
  versions: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["close", "restore"]);

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString();
};
</script>

<style lang="scss">
.el-dialog.app-modal.version-history-modal {
  max-width: 700px;
}
</style>

<style lang="scss" scoped>
.modal-body {
  max-height: 65vh;
  overflow-y: auto;
}

.no-versions {
  text-align: center;
  padding: 32px;
  color: $color-text-muted;
}

.versions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.version-item {
  border: 1px solid $color-border;
  border-radius: 10px;
  padding: 16px;
}

.version-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.version-number {
  font-weight: 600;
  color: $color-ink;
}

.version-date {
  font-size: 13px;
  color: $color-text-muted;
}

.version-meta {
  font-size: 13px;
  color: $color-text-muted;
  margin-bottom: 10px;
}

.version-preview {
  margin-bottom: 12px;

  summary {
    cursor: pointer;
    color: $color-primary;
    font-size: 14px;
    font-weight: 600;
  }
}

.preview-content {
  margin-top: 8px;
  padding: 12px;
  background: $color-surface-muted;
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
}

.preview-section {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 13px;
    color: $color-text-muted;
  }

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 12px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  }
}
</style>
